import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from "app/_services/settings.service";
import { environment } from '../../../environments/environment';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class UserValidationService extends BaseService {
    private _domain: string = '/verification/users';
    public enableUserVerification: boolean = environment.enableUserVerification;

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public getUser(): Observable<any> {
        let userId = this.userService.user().id;

        return this.config.executeGet({ url: `${this._domain}/${userId}` });
    }

    public updateUserData(firstName: string, lastName: string, phone: string): Observable<any> {
        const userId = this.userService.user().id;
        const body = { firstName, lastName, phone };

        return this.config.executePost({ url: `${this._domain}/${userId}/name-phone`, body });
    }

    public updateUserEmail(email: string): Observable<any> {
        const userId = this.userService.user().id;

        return this.config.executePost({ url: `${this._domain}/${userId}/email?email=${email}` });
    }

    public updateUserEmailConfirmation(token: string): Observable<any> {
        const userId = this.userService.user().id;

        return this.config.executePost({ url: `${this._domain}/${userId}/email/${token}` });
    }

    public updateUserWhatsapp(whatsapp: string): Observable<any> {
        const userId = this.userService.user().id;

        return this.config.executePost({ url: `${this._domain}/${userId}/whatsapp?whatsapp=${whatsapp}` });
    }

    public updateUserWhatsappConfirmation(token: string): Observable<any> {
        const userId = this.userService.user().id;

        return this.config.executePost({ url: `${this._domain}/${userId}/whatsapp/${token}` });
    }
}
